// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SportTicketSingolaMultipla_wrapper__uT6LP"};